import React from "react";
import { useState } from "react";
import Drawer from "@mui/material/Drawer";
import {
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import CloseIcon from "../../assets/images/svgs/CloseIcon.svg";
import { useEffect } from "react";
import { message } from "antd";
import CustomTextField from "../common/InputField/Input";
import {
  postPaymentForNightAudit,
  updateShowTakePaymentDrawer,
} from "../../reducer/nightAuditReducer";
import { nightAuditdDawerWidth } from "../../utils/nightAuditHelper";
import moment from "moment";

export default function TakePaymentDrawer({ selectedInvoice }) {
  const { hotelDetails } = useSelector((store) => store.login);

  const { showTakePaymentDrawer } = useSelector((store) => store.nightAudit);
  const { paymentModesResponse } = useSelector((store) => store.payments);

  const dispatch = useDispatch();

  const [amount, setAmount] = React.useState("");
  const [paymentMode, setPaymentMode] = React.useState("cash");
  const [transactionNo, setTransactionNo] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [methodToPartyId, setMethodToPartyId] = useState({});
  const [partyIdToMethod, setPartyIdToMethod] = useState({});
  const [paymentModePartyId, setPaymentModePartyId] = useState("");

  const { currentNightAuditDate } = useSelector((store) => store.appHeader);

  useEffect(() => {
    if (
      Array.isArray(paymentModesResponse) &&
      paymentModesResponse?.length &&
      showTakePaymentDrawer
    ) {
      let updatedObj = {};
      const idToMethodMap = {};
      paymentModesResponse?.forEach((mode) => {
        const { method, partyId } = mode;
        updatedObj[method] = partyId;
        idToMethodMap[partyId] = method;
      });
      setMethodToPartyId(updatedObj);
      setPartyIdToMethod(idToMethodMap);
      setPaymentModePartyId(updatedObj["cash"]);
    }
  }, [paymentModesResponse, showTakePaymentDrawer]);

  const addPayment = async () => {
    if (Boolean(amount)) {
      setLoading(true);

      // let roomInvoiceId = Array.isArray(invoiceDetails)
      //   ? invoiceDetails
      //       ?.filter((Obj) => Obj?.invoiceType === "roomBill")
      //       ?.map((Obj) => Obj?.id)?.[0]
      //   : "";

      let zoneOffset = hotelDetails?.zoneOffset;

      const startOfDayWithOffset = moment(currentNightAuditDate)
        .startOf("day")
        .utcOffset(zoneOffset)
        .toISOString();

      const endOfDayWithOffset = moment(currentNightAuditDate)
        .endOf("day")
        .utcOffset(zoneOffset)
        .toISOString();

      const paymentPayload = {
        amount: amount,
        bookingId: selectedInvoice?.bookingId,
        hotelId: hotelDetails?.id,
        method: paymentMode,
        transactionNo: transactionNo,
        invoiceId: selectedInvoice?.id,
        paymentModePartyId,
      };

      let invoicePayload = {
        hotelId: hotelDetails?.id,
        pageNumber: 0,
        pageSize: 20,

        startDate: startOfDayWithOffset,
        endDate: endOfDayWithOffset,
      };

      const payload = {
        invoicePayload,
        paymentPayload,
      };

      dispatch(postPaymentForNightAudit(payload));

      await dispatch(updateShowTakePaymentDrawer());
      await setLoading(false);
    } else {
      message.info("Please enter amount");
    }
  };

  useEffect(() => {
    let total = selectedInvoice?.total;
    let paid = selectedInvoice?.paid;

    let due = total - paid;
    due = due > 0 ? due?.toFixed(2) : 0;

    setAmount(due);

    return () => {
      setAmount("");
      setPaymentMode("cash");
      setTransactionNo("");
      setLoading(false);
      setMethodToPartyId({});
      setPaymentModePartyId("");
    };
  }, [showTakePaymentDrawer]);

  const handleClose = () => {
    setAmount("");
    setPaymentMode("cash");
    setTransactionNo("");
    setLoading(false);
    setMethodToPartyId({});
    setPaymentModePartyId("");
    dispatch(updateShowTakePaymentDrawer());
  };

  return (
    <Drawer
      PaperProps={{
        sx: {
          width: nightAuditdDawerWidth,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        },
      }}
      sx={{
        "& .MuiDrawer-root": {
          position: "absolute",
          marginLeft: "auto",
          right: 0,
        },
        "& .MuiPaper-root": {
          position: "absolute",
          marginLeft: "auto",
        },
      }}
      anchor={"bottom"}
      open={showTakePaymentDrawer}
      onClose={loading ? undefined : handleClose}
    >
      <div className="flex flex-col mx-3 gap-5 items-start my-2  ">
        <div className="flex w-[100%] justify-between items-center px-3 py-3 ">
          <h2 className="font-[500] text-[1rem] text-fg-secondary font-body">
            Take Payment
          </h2>

          <div
            onClick={loading ? undefined : handleClose}
            className="cursor-pointer"
          >
            <img src={CloseIcon} alt="" />
          </div>
        </div>

        <div className="flex flex-col mx-5 mb-3 gap-3 items-center w-[100%]">
          <div className="flex  w-[90%] mx-5 gap-7 justify-center">
            <div className="w-[50%]">
              <CustomTextField
                label="Amount"
                isManadatory={true}
                value={amount}
                onChange={(value) => setAmount(value)}
                type="text"
              />
            </div>

            <FormControl sx={{ width: "45%", color: "rgb(var(--color-black) / 0.3)" }} size="small">
              <InputLabel
                id="paymentMode"
                sx={{ color: "rgb(var(--color-black) / 0.3)", fontSize: "15px" }}
              >
                Payment Mode
              </InputLabel>

              <Select
                labelId="SelectPaymentLabel"
                id="selectPayment"
                label="Payment Mode "
                value={Boolean(paymentModePartyId) ? paymentModePartyId : ""}
                onChange={(e) => {
                  setPaymentModePartyId(e.target.value);
                  setPaymentMode(partyIdToMethod[e.target.value]);
                }}
                sx={{
                  borderRadius: "6px",
                  fontSize: "15px",
                  "& .MuiSelect-icon": {
                    color: "rgb(var(--color-accent))",
                  },
                }}
              >
                {paymentModesResponse?.map((mode) => {
                  const { method, partyId, paymentMode } = mode;
                  return (
                    <MenuItem
                      value={partyId}
                      sx={{
                        fontSize: "14px",
                        color: "rgb(var(--color-black) / 0.6)",
                        fontFamily: "var(--font-body)",
                        fontWeight: 400,
                      }}
                    >
                      {paymentMode}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>

          <div className="w-[89%]">
            <CustomTextField
              label={paymentMode === "cash" ? "Cashier" : "Transaction No"}
              isManadatory={false}
              value={transactionNo}
              onChange={(value) => setTransactionNo(value)}
              type="text"
            />
          </div>
        </div>
      </div>

      <button
        className={`bg-primary capitalize text-fg-inverse w-full h-[3rem] `}
        onClick={() => addPayment()}
      >
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          <div>Take Payment</div>
        )}
      </button>
    </Drawer>
  );
}
